import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { walletAddressTypeImage } from "@lib/helpers/ColorHelper";
import { shortenString } from "@lib/helpers/StringHelper";
import { WalletAddress as WalletAddressType } from "@lib/types";
import { SendByteWalletAddress as SendByteWalletAddressType } from "@lib/types/SendByte";
import { Typography } from "antd";
import { FaCopy } from "react-icons/fa";

type Props = {
  walletAddress: {
    address: string;
    network?:
      | WalletAddressType["network"]
      | SendByteWalletAddressType["network"];
  };
  showNetwork?: boolean;
  shortenAddress?: boolean | number;
  showCopyButton?: boolean;
};

export default function WalletAddressText({
  walletAddress,
  showNetwork = true,
  shortenAddress = false,
  showCopyButton = true,
}: Props) {
  const { address = "", network = "USDT" } = walletAddress || {};

  const shortenCount = typeof shortenAddress === "number" ? shortenAddress : 10;
  const shortenAddressText = shortenCount
    ? shortenString(address, shortenCount, false)
    : address;

  if (!address) return <Typography.Text>N/A</Typography.Text>;

  return (
    <StyledFlex style={{ gap: 5 }}>
      {showNetwork && (
        <img
          src={walletAddressTypeImage(network as WalletAddressType["network"])}
          style={{ maxHeight: "15px" }}
        />
      )}
      <Typography.Text
        copyable={
          showCopyButton ? { text: address, icon: <FaCopy /> } : undefined
        }
      >
        {shortenAddressText}
      </Typography.Text>
    </StyledFlex>
  );
}
